'use strict';

var defaultTheme = require('./defaultTheme-ea44e34a.js');
var React = require('react');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject;
var SectionSeparator$1 = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject || (_templateObject = defaultTheme._taggedTemplateLiteral(["\n height: ", ";\n width: ", ";\n\n ", "\n"])), function (props) {
  return props.vertical ? '100%' : '1px';
}, function (props) {
  return props.vertical ? '1px' : '100%';
}, function (props) {
  return props.theme.themeProp('background-color', props.theme.getColor('gray-800'), props.theme.getColor('gray-200'));
});

var SectionSeparator = React__default['default'].forwardRef(function SectionSeparator(_ref, forwardedRef) {
  var vertical = _ref.vertical,
      props = defaultTheme._objectWithoutProperties(_ref, ["vertical"]);

  return React__default['default'].createElement(SectionSeparator$1, defaultTheme._extends({
    vertical: vertical,
    ref: forwardedRef
  }, props));
});
SectionSeparator.propTypes = process.env.NODE_ENV !== "production" ? {
  vertical: defaultTheme.PropTypes.bool
} : {};
SectionSeparator.defaultProps = {
  vertical: false
};

exports.SectionSeparator = SectionSeparator;
